import { type ReactElement } from 'react'
import { cn } from '@util'
import { useTranslation } from '@front/model'
import { TButton, type TButtonProps } from '../buttons'
import { type NavbarCollapseProps } from './Navigation'

type CollapsibleProps = Extract<NavbarCollapseProps, { collapsible: true }>
type Props = Pick<CollapsibleProps, 'isOpen' | 'toggle'> &
  Omit<TButtonProps, 'buttonType' | 'icon' | 'pos' | 'variant' | 'onClick'>
export const NavigationCollapseButton = ({ isOpen, toggle, className, ...props }: Props): ReactElement => {
  const { t } = useTranslation()

  return (
    <TButton
      buttonType='icon-full'
      className={cn('absolute top-1/2 -right-4 -translate-y-1/2', className)}
      icon='chevron_forward'
      iconProps={{ className: cn('transition-all duration-500', isOpen ? 'rotate-180' : 'rotate-0') }}
      onClick={toggle}
      pos='absolute'
      tooltip={isOpen ? t('Collapse Navigation') : t('Expand Navigation')}
      variant='secondary'
      {...props}
    />
  )
}
